<template>
    <div :class="getCSSClass('tooltip-content-container')"
         :ref="'contentcontainer'"
         v-on:mouseenter="loadAndShow"
         v-on:mouseleave="hide"
    >
        <slot></slot>
        <div style="position: fixed; transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out; z-index: 50; max-height: 70vh; overflow-y: auto"
             :ref="'container'"
             :style="{'opacity': show ? 1 : 0, 'visibility': show ? 'visible' : 'hidden'}"
             :class="getCSSClass('tooltip-popup')"
             v-html="content"
        >
        </div>
    </div>

</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            operationsUrl: {type: String},
            operation: {type: String, default: 'fetchTooltipdata'},
            subject: {},
            delay: {type: Number, default: 300},
        },
        data: function () {
            return {
                debounce: 0,
                content: '',
                show: false,
                cursorPosition: {type: Object, default: () => {return {x: 0, y: 0}}},
            }
        },
        mounted() {
        },
        methods: {
            hide: function() {
                this.show = false;
                window.clearTimeout(this.debounce);
            },
            loadAndShow: function(event) {
                window.clearTimeout(this.debounce);
                this.debounce = window.setTimeout(() => {
                    this.cursorPosition.x = event.clientX;
                    this.cursorPosition.y = event.clientY;
                    window.axios.post(this.operationsUrl, {subject: this.subject, operation: this.operation})
                        .then((response) => {
                            this.content = response.data;
                            this.show = true;
                        })
                }, this.delay);
            }
        },
        computed: {},
        watch: {
            show: function(value) {
                if (value === true) {
                    let openToX = this.cursorPosition.x + 250 > window.innerWidth ? 'right' : 'left';
                    let openToY = this.cursorPosition.y > window.innerWidth / 2 ? 'bottom' : 'top';
                    /*
                    if (this.revertXOpening) {
                        openToX = openToX == 'left' ? 'right' : 'left';
                    }
                     */
                    if (openToX == 'left') {
                        this.$refs['container'].style['right'] = 'unset';
                        this.$refs['container'].style[openToX] = this.cursorPosition.x.toString() + 'px';
                    } else {
                        this.$refs['container'].style['left'] = 'unset';
                        this.$refs['container'].style[openToX] = (window.innerWidth - this.cursorPosition.x).toString() + 'px';
                    }
                    if (openToY == 'top') {
                        this.$refs['container'].style['bottom'] = 'unset';
                        this.$refs['container'].style.top = this.cursorPosition.y.toString()+'px';
                    } else {
                        this.$refs['container'].style['top'] = 'unset';
                        this.$refs['container'].style.bottom = (window.innerHeight - this.cursorPosition.y).toString()+'px';
                    }
                    this.$nextTick(() => {
                        let bcr = this.$refs['container'].getBoundingClientRect();
                        if (bcr.top + bcr.height > window.innerHeight) {
                            this.$refs['container'].style.top = (window.innerHeight - bcr.height - 20).toString()+'px';
                        }
                    })
                } else {
                }
            }

        }

    }
</script>
